import script from "./SupplierDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SupplierDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SupplierDashboard.vue?vue&type=style&index=0&id=e605025c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e605025c"]])

export default __exports__